import { EMPTY_OBJECT } from '../../../../constants/common'
import { ControlDate } from '../ControlDate'

import { control } from './control'

/**
 * @param {string} name
 * @param {Date} value
 * @param {Object} defaultProps
 */
export function date(name, value, defaultProps = EMPTY_OBJECT) {
  return control(name, value, ControlDate, defaultProps)
}
